import apiClient from './client';
import type { Recipe } from './recipes';

export interface Collection {
  id: string;
  name: string;
  color: string;
  recipe_count: number;
  created_at: string;
  updated_at: string;
}

export interface CollectionCreateInput {
  name: string;
  color?: string;
}

export interface CollectionUpdateInput {
  name?: string;
  color?: string;
}

export const collectionsApi = {
  list: async () => {
    const response = await apiClient.get<{
      data: { collections: Collection[] };
    }>('/collections');
    return response.data.data.collections;
  },

  get: async (id: string) => {
    const response = await apiClient.get<{ data: Collection }>(`/collections/${id}`);
    return response.data.data;
  },

  create: async (data: CollectionCreateInput) => {
    const response = await apiClient.post<{ data: Collection }>('/collections', data);
    return response.data.data;
  },

  update: async (id: string, data: CollectionUpdateInput) => {
    const response = await apiClient.put<{ data: Collection }>(`/collections/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/collections/${id}`);
  },

  getRecipes: async (id: string) => {
    const response = await apiClient.get<{ data: { recipes: Recipe[] } }>(`/collections/${id}/recipes`);
    return response.data.data.recipes;
  },

  addRecipe: async (collectionId: string, recipeId: string) => {
    const response = await apiClient.post<{ data: { message: string } }>(`/collections/${collectionId}/recipes`, {
      recipe_id: recipeId,
    });
    return response.data.data;
  },

  removeRecipe: async (collectionId: string, recipeId: string) => {
    await apiClient.delete(`/collections/${collectionId}/recipes/${recipeId}`);
  },
};
